import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-card/50">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Adjusted to grid-cols-5 to accommodate the new column elegantly */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8">
          
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Zap className="h-6 w-6 text-accent" strokeWidth={1.5} />
              <span className="font-outfit font-semibold text-lg">ShipTesla</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Premium vehicle transport for Tesla owners. Safe, reliable, and hassle-free.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit font-semibold mb-4 text-sm">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/quote" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Get a Quote
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Insurance
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Routes */}
          <div>
            <h4 className="font-outfit font-semibold mb-4 text-sm">Popular Routes</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/routes/california-to-texas" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  California to Texas
                </Link>
              </li>
              <li>
                <Link to="/routes/california-to-carolina" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  California to Carolina
                </Link>
              </li>
              <li>
                <Link to="/routes/tesla-to-hawaii" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Tesla to Hawaii
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-outfit font-semibold mb-4 text-sm">Support</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-outfit font-semibold mb-4 text-sm">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 space-y-3">
          <p className="text-[11px] text-muted-foreground/70 leading-relaxed max-w-2xl">
            Deposit is fully refundable until dispatch confirmation. After dispatch, the deposit is non-refundable.
            Delivery times are estimates and not guaranteed. ShipTesla is not affiliated with Tesla, Inc.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-xs text-muted-foreground">
              &copy; {new Date().getFullYear()} ShipTesla. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground">
              ShipTesla is not affiliated with Tesla, Inc.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};